<template>
  <v-card class="elevation-0">
        <v-card-title class="grey--text">
              <span class="display-1 ">{{item.lastname}} {{item.firstname}}</span> <span class="ml-2 display-1 primary--text">{{item.id}}</span>
        </v-card-title>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">phone</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>(+32) {{item.mobile || item.tel}}</v-list-item-title>
              <v-list-item-subtitle>Mobile</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>chat</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">mail</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{item.email}}</v-list-item-title>
              <v-list-item-subtitle>Personal</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">location_on</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{address || item.address}}</v-list-item-title>
              <v-list-item-subtitle>{{item.zip}} {{item.city}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
</template>
<script>
import Auth from '@/core/auth';
export default {
  props: ['id', 'address'],
  data () {
    return {
      item: {}
    }
  },
  computed: {
    driver: Auth.getUser
  },
  methods: {
    getdata () {
      var app = this;
      var id = this.id;
      console.log('update client detail');
      this.$http
      .get('api/client/' + id)
      .then(response => {
        console.log('response client data:', response.data);
        app.item = response.data[0];
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  },
  watch: {
    id () {
      console.log('updated client id:', this.id)
      this.getdata();
    }
  },
  created () {
    this.getdata();
  }
}
</script>
